import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import "@/index.css";
import App from "@/App";
import { AdminDashboard } from "@/components/AdminDashboard";
import { PayRemainingBalance } from "@/components/PayRemainingBalance";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/admin/*" element={<AdminDashboard />} />
        <Route path="/pay-balance/:bookingId" element={<PayRemainingBalance />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>,
);
